<template>
  <div>
    <div class="form-group-style">
      <el-form
        class="form-container"
        :model="info"
        ref="ModelForm"
        :rules="modelRules"
      >
        <div class="form-item bidding-tips">
          <div class="form-label">
            <span class="label">模板添加说明：</span>
          </div>
          <div class="form-input-item">
            <el-form-item>
              <p>
               1.动态取值字段请用<span class="red">[标签名]</span>表示，如<span class="red">[城市]</span> 在长沙站生成导购文章内展示为：长沙，广州站生成导购文章内展示为：广州。
              </p>
              <p>
               2.支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span> 进行查看。
              </p>
              <p>3.选择文章类型后可在标题、关键词、正文中点击添加内容项按钮进行添加内容。</p>
            </el-form-item>
          </div>
        </div>
       <div class="form-item">
          <div class="form-label">
            <span class="label">模板名称：</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="name">
              <el-input
                placeholder="请输入模板名称"
                class="input-control"
                v-model="info.name"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">文章类型</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="type_id">
             <el-select v-model="info.type_id" placeholder="全部">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
            </el-select>
            </el-form-item>
          </div>
        </div>
        
        <div class="form-item">
          <div class="form-label">
            <span class="label">文章标题</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="title">
              <el-input
                    placeholder="请输入文章标题"
                    class="input-control"
                    v-model="info.title"
              ></el-input>
            </el-form-item>
          </div>
           <el-button
                class="add-btn"
                icon="el-icon-plus"
                @click="handleAddCnt(1,'标题')"
            >添加标题项
            </el-button>
        </div>
        <div class="form-item">
            <div class="form-label">
                <span class="label">关键词</span>
                <label class="warn">*</label>
            </div>
            <div class="form-input-item">
                <el-form-item prop="keywords">
                <el-tag
                    class="topic-tag"
                    v-model="ztTags"
                    v-for="(tag,index) in ztTags"
                    :key="index"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                    >{{ tag }}</el-tag
                >
                <template v-if="ztTags.length < 4">
                    <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    max-length="10"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                    ></el-input>
                    <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                    >+ 添加关键字</el-button
                    >
                </template>
                </el-form-item>
                
            </div>
            <el-button
                class="add-btn"
                icon="el-icon-plus"
                @click="handleAddCnt(2,'关键字')"
            >添加关键字项
            </el-button>
        </div>

         <div class="form-item">
          <div class="form-label">
            <span class="label">正文</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item editor" style="width:1000px">
              <el-form-item prop="description">
                <UE :options="eidtorOptions" defaultMsg="" @addContent="handleAddCnt3"  @addhouse="showHouseAdd" ref="ue" />
              </el-form-item>
            </div>
        </div>

        <div class="form-button">
            <el-button type="primary" @click="submitForm('ModelForm',1)"
                >保存并预览</el-button>
            <el-button type="primary" @click="submitForm('ModelForm',2)"
                >保存</el-button
            >
            <el-button type="info" plain @click="toList()">取 消</el-button>
        </div>
      </el-form>
    </div>
    <add-content ref="addContent" :callback="update"></add-content>
    <insert-house ref="insertHouse" @insertHouseCard="insertHouseCard" @showTagLib="showTagLib"></insert-house>
    <tag-lib ref="tagLib"></tag-lib>
  </div>
</template>
<script>
import { validateEmpty } from "@/utils/validate";
import { NEWS_MODEL } from "@/config/index";
import { UPLOAD_CODE } from "@/config/index";
import EditorBar from "@/components/newsModelEditor/modelEditor";
import UE from '@/components/editoritem/uEditor';
import {getNewsModelDetail,newsModelAdd,editNewsModel} from '@/service/newsModel'
import addContent from "./component/addContent";
import insertHouse from "./component/insertHouse";
import TagLib from '../content/component/tagLib';

export default {
  name: "List",
  components: {
    EditorBar,
    addContent,
    insertHouse,
    TagLib,
    UE
  },
  data() {
    return {
      info: {
        name: "",
        title:"",
        description: "",
        keywords: "",
        type_id: 1,
      },
      houseCardId:'',
      modelId:'',
      ztTags: [],
      typeList:[],
      inputVisible: false,
      inputValue: "",
      isClear: false,
      modelRules: {
        name: [
          { validator: validateEmpty, result: "模板名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度1到50个字符" },
        ],
        title: [
          { validator: validateEmpty, result: "文章标题", trigger: "blur" },
          { min: 1, max: 50, message: "长度1到50个字符" },
        ],
        keywords: [{ required: true, message: "请至少添加一个关键字" }],
        description: [
          { validator: validateEmpty, result: "正文", trigger: "blur" },
          { min: 10, max: 8000, message: "长度10到8000个字符" }
        ]
      },
      // 编辑器配置
      eidtorOptions: {
        pictureConfig: {
          code: UPLOAD_CODE.news
        },
        videoConfig: {
          code: UPLOAD_CODE.newsVideo
        },
        wordLimit:12000,
        uploadType:'common',
        config: {
          items : ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen', 'addhouse','addContent','addIframe'],
        }
      },
    };
  },
  mounted(){
    const id = this.$route.query.id;
    if (id) {
        this.modelId = id
        this.getModelDetail(id,'edit')
    }
    this.typeList = NEWS_MODEL.news_types;
  },
  methods: {
    showTagLib(){
        this.$refs.tagLib.openMenu()
    },
    handleClose(tag) {
      this.ztTags.splice(this.ztTags.indexOf(tag), 1);
      this.info.keywords = this.ztTags.join(",");
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && inputValue.length <= 10) {
        this.ztTags.push(inputValue);
        this.info.keywords = this.ztTags.join(",");
        this.inputVisible = false;
        this.inputValue = "";
      } else if (inputValue == "") {
        this.inputVisible = false;
        this.inputValue = "";
      } else {
        this.$message({
          type: "error",
          message: "关键词最多10个字符",
        });
        return false;
      }
    },
    async getModelDetail(id,type){
      await getNewsModelDetail(id).then((data) => {
        this.info = data;
        if(type && type != 'add'){
          this.$refs.ue.pushContent(data.description);         
        }
        this.ztTags = data.keywords.split(',');
        this.houseCardId = data.rcid;
      })
    },
    resetForm() {
      this.$refs.modelRules && this.$refs.modelRules.clearValidate();
    },
    toList() {
      this.$router.push("newsModel");
    },
    changeC(val){
        this.info.description = val;
    },
    handleAddCnt(type,title) {
        this.$refs.addContent
        && this.$refs.addContent.open(type,title,this.info.type_id)
    },
    handleAddCnt3(){
      this.$refs.addContent
        && this.$refs.addContent.open(3,'正文',this.info.type_id)
    },
    update(data){
      if(data.body_type == 1){
          this.info.title = data.body
      }else if(data.body_type == 2){
          this.ztTags = data.body.split(',')
      }else{
        this.insertContent(data.body)
      }
    },
    insertContent(data){
      let newA = [];
      data.forEach(el => {
          el = '<p>'+el.replace(/\n/g, '<br>')+'</p>';
          newA.push(el)
        });
      var a = newA.join(" ")  
      this.$refs.ue.pushContent(a)
    },
    showHouseAdd(){
       this.$refs.insertHouse
        && this.$refs.insertHouse.open(this.houseCardId)
    },
    insertHouseCard(data){
      this.houseCardId = data.id;
      const obj = document.querySelector('.ke-edit-iframe').contentDocument;
      const houseUnit = obj.getElementsByTagName("house");
      var text = data.rules_name+"("+data.text+")"+',数量'+data.num;
      if(houseUnit && houseUnit.length){
        houseUnit[0].setAttribute('data-rcid',data.id);
         houseUnit[0].innerHTML=text
      }else{
        this.$refs.ue.pushContent('&nbsp;&nbsp;<house class="houseUnit" data-rcid="'+data.id+'">'+data.rules_name+"("+data.text+")"+',数量'+data.num+'</house>');

      }
    },
    submitForm(formName,type) {
      this.info.keywords = this.ztTags.join(",");
      this.info.description = this.$refs.ue.getContent().html;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let query = this.info;
          if(this.modelId){
            this.edit(this.modelId,query,type);
          }else{
            console.log(query)
            this.add(query,type);
          }
        } else {
          return false;
        }
      });
    },
    add(query,type){
      newsModelAdd(query)
        .then((data) => {
          this.$message({
            message: "添加成功",
            type: "success",
            duration: 3 * 1000,
          });
          if(type == 1){
            let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
            let url = "https://cs."+siteurl+'/zixun/preview/'+data.id+'.html';
            window.open(url,'_blank');
            this.modelId = data.id
            this.getModelDetail(data.id,'add')
          }else{
            this.toList();
          }
        })
        .catch((err) => {
          this.$message({
            message: err.message || "添加失败",
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
    edit(id,query,type){
      editNewsModel(id,query)
        .then((data) => {
          this.$message({
            message: "编辑成功",
            type: "success",
            duration: 3 * 1000,
          });
          if(type == 1){
            let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
            let url = "https://cs."+siteurl+'/zixun/preview/'+data.id+'.html';
            window.open(url,'_blank');
          }else{
            this.toList();
          }        
        })
        .catch((err) => {
          this.$message({
            message: err.message || "编辑失败",
            type: "error",
            duration: 3 * 1000,
          });
        });
    }
  },
};
</script>
<style scoped lang="less">

.form-group-style .form-input-item .el-tag /deep/ .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;
}
.form-group-style .form-container .form-item .form-label {
  width: 20%;
}
.form-group-style .form-container .form-input-item {
  width: 40%;
}
.form-group-style {
  min-height: 600px;
  background-color: #fff;
}
.bidding-tips .form-input-item {
  width: 50% !important;
}
.huxing-input {
  display: -webkit-box;
  height: 152px;
  .el-form-item {
    -webkit-box-flex: 1;
  }
  .labels {
    font-size: 13px;
    color: #666;
    padding: 0 8px;
    display: block;
  }
  .flex-all {
    -webkit-box-flex: 1;
  }
}
.checked-labels {
  border: 1px solid #e4e7ed;
  font-size: 13px;
  color: #666;
  padding: 0px 16px;
  border-radius: 3px;
  margin: 0 15px 15px 0;
  display: inline-block;
  position: relative;
  cursor: pointer;
  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    transition: all 0.1s linear;
    opacity: 0;
    .el-icon-delete {
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 15px;
      height: 20px;
      display: block;
    }
  }
  &:hover {
    .shadow {
      opacity: 1;
    }
  }
}
p.tip {
  color: #666;
  margin-left: 20px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: auto;
  margin-left: 10px;
  vertical-align: bottom;
}
.red{
    color:red;
}
.add-btn{
  margin-left:10px;
}
</style>